(function paycheckRRHHEditControllerDefinition() {
    'use strict';

    angular.module('PaycheckRRHH')
        .controller('PaycheckRRHHEditController', [
            '$filter', '$state', '$scope', '$stateParams', 'errorsExtend', 'processService', 'fileWorkflowService', 'authExtend', 'configViewService', '$q', '$window', 'profileCertificateService', '$parse', 'config',
            function paycheckRRHHEditController($filter, $state, $scope, $stateParams, errors, processService, fileWorkflowService, auth, configViewService, $q, $window, profileCertificateService, $parse, config) {

                $scope.legend = { type: 'warning', message: 'NoActiveEmpleyeerCertificate' };
                $scope.callbackUrl = '#/PaycheckRRHH/Find/SignPending';

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.tmpProcess = {
                    name: '',
                    metadatas: []
                };

                $scope.getConfig = function (paycheck) {
                    $scope.paycheck = paycheck;
                    return configViewService.getById('CPPPaycheckRRHH');
                };

                $scope.getCertificates = function (config) {
                    $scope.configView = config;
                    var certificateFilters = {
                        organizationalUnitId: $scope.paycheck.organizationalUnitId,
                        enabled: true,
                        active: true,
                        type: 1, // Empleador
                        signType: 0 // Firma simple
                    };

                    return profileCertificateService.get(certificateFilters);
                };

                $scope.setConfig = function (certificates) {
                    var metadatas = [];
                    var processType = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.paycheck.paycheckTypeId }, true);
                    if (processType.length == 0) {
                        $scope.paycheck.metadataValues = metadatas;
                        return;
                    }

                    processType[0].metadatas.forEach(function (paycheckMetadata) {
                        if (paycheckMetadata.editCriteria) {
                            var metadataFound = $filter('filter')($scope.paycheck.metadataValues, { systemName: paycheckMetadata.systemName }, true);

                            var value = null;
                            var desc = null;
                            var isVisible = true;

                            if (metadataFound.length > 0) {
                                value = metadataFound[0].value;
                                desc = metadataFound[0].description;
                            }

                            if (paycheckMetadata.systemName === '_idCertificado' ||
                                paycheckMetadata.systemName === '_cpassword') {
                                isVisible = false;
                            }


                            $scope.tmpProcess.metadatas.push({
                                idObject: $scope.paycheck.id + '' + paycheckMetadata.metadataId,
                                metadataId: paycheckMetadata.metadataId,
                                metadataType: paycheckMetadata.metadataType.toLowerCase(),
                                metadataLabel: paycheckMetadata.editCriteria.name,
                                metadataIsRequired: paycheckMetadata.editCriteria.isRequired && isVisible,
                                metadataIsVisible: isVisible,
                                metadataReadOnly: !paycheckMetadata.editCriteria.isEditable,
                                metadataEnabled: paycheckMetadata.editCriteria.isEditable,
                                maskOptions: paycheckMetadata.maskOptions,
                                metadataValue: value,
                                metadataOptions: paycheckMetadata.metadataOptionValues,
                                systemName: paycheckMetadata.systemName,
                                order: paycheckMetadata.editCriteria.order
                            });
                        }
                    });

                    if (certificates.length > 0) {
                        $scope.addCertificateMetadata(certificates);
                    } else {
                        $scope.signNoCertificate = true;
                    }

                    $scope.tmpProcess.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    var item = {};

                    $scope.paycheck.files.forEach(function (file) {
                        item.creationDate = file.creationDate;
                        item.name = file.name;
                        item.size = file.size;
                        item.id = file.id;
                        item.stream = null;
                    });

                    $scope.previewFile(item, 0);
                };

                $scope.loadFile = function (fileId) {
                    return fileWorkflowService.getById(fileId);
                };

                $scope.controlChanged = function (metadata) {
                    if (metadata.systemName === '_wcertificate') {
                        var selectedOption = $filter('filter')(metadata.metadataOptions, { value: metadata.metadataValue }, true);
                        if (selectedOption.length === 1) {
                            $scope.selectedCertificate = selectedOption[0];
                            $scope.isNacion = $scope.selectedCertificate.description === 'Nacion';
                            $scope.certId = $scope.selectedCertificate.id;

                            angular.forEach($scope.tmpProcess.metadatas, function (m) {
                                if (m.systemName === '_cpassword') {
                                    m.metadataIsVisible = $scope.selectedCertificate.requirePassword;
                                    m.metadataIsRequired = $scope.selectedCertificate.requirePassword;
                                    m.metadataValue = undefined;
                                }

                                if (m.systemName === '_idCertificado') {
                                    m.metadataValue = $scope.selectedCertificate.id;
                                }
                            });
                        }
                    }
                }

                $scope.showError = function (error) {
                    errors.showError(error);
                    $scope.cancel();
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileWorkflowService.preview(item, true).then(function (result) {
                        $scope.preview.content = result;
                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            //$scope.hidePreview();
                        }
                    });
                };

                $scope.addCertificateMetadata = function (certificates) {
                    var metadataCertificates = {
                        idObject: $scope.paycheck.id + '_wcertificate',
                        systemName: '_wcertificate',
                        metadataType: 'radio',
                        metadataLabel: 'Certificado',
                        metadataIsVisible: certificates.length > 1,
                        metadataEnabled: certificates.length > 1,
                        metadataIsRequired: true,
                        metadataValue: undefined,
                        order: 5,
                        metadataOptions: []
                    };

                    angular.forEach(certificates, function (certificate) {
                        var description = certificate.provider;
                        if (certificate.expirationDate) {
                            description = certificate.provider + ' (' + $filter('date')(certificate.expirationDate, 'dd/MM/yyyy') + ')';
                        }

                        metadataCertificates.metadataOptions.push({
                            id: certificate.id,
                            value: certificate.id,
                            description: description,
                            requirePassword: certificate.requirePassword,
                            supportDisagreement: certificate.supportDisagreement,
                            action: certificate.singleSignatureAction
                        });
                    });

                    if (metadataCertificates.metadataOptions.length === 1) {
                        metadataCertificates.metadataValue = metadataCertificates.metadataOptions[0].value;
                        $scope.controlChanged(metadataCertificates);
                    }

                    $scope.tmpProcess.metadatas.push(metadataCertificates);
                };

                $scope.cancel = function () {

                    processService.checkin($stateParams.id).then(function () {
                        $window.history.back();
                    }, function () {
                        errors.showError('PayCheckCheckInError');
                    });
                };

                $scope.execute = function () {
                    if (!$scope.paycheckRRHHEdit.$valid) {
                        $scope.paycheckRRHHEdit.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if (!$scope.selectedCertificate.action) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    var method = $parse($scope.selectedCertificate.action);

                    if (!method($scope)) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    return method($scope)();
                };

                $scope.signEncode = function () {
                    $scope.tmpProcess.metadatas.forEach(function (tmpProcessMetadata) {
                        var metadataFound = $filter('filter')($scope.paycheck.metadataValues, { metadataId: tmpProcessMetadata.metadataId }, true);

                        if (metadataFound.length === 1) {
                            metadataFound[0].value = tmpProcessMetadata.metadataValue;
                        } else if (metadataFound.length === 0) {
                            $scope.paycheck.metadataValues.push({
                                metadataId: tmpProcessMetadata.metadataId,
                                name: tmpProcessMetadata.metadataLabel,
                                isRequired: tmpProcessMetadata.metadataIsRequired,
                                isVisible: tmpProcessMetadata.metadataIsVisible,
                                order: tmpProcessMetadata.order,
                                systemName: tmpProcessMetadata.systemName,
                                type: tmpProcessMetadata.metadataType,
                                value: tmpProcessMetadata.metadataValue
                            });
                        }
                    });

                    return processService.modifyAndSend($scope.paycheck).then(function () {
                        $state.go('paycheck-rrhh-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.load = function () {
                    $scope.signPermission = auth.isInRole('PAYCHECK SIGN');
                    $scope.signAction = 'PaycheckRRHHSign';

                    processService.checkout($stateParams.id)
                        .then($scope.getConfig, $scope.showError)
                        .then($scope.getCertificates, $scope.showError)
                        .then($scope.setConfig, $scope.showError);
                };

                $scope.signLakaut = function () {
                    $scope.isInProgress = true;

                    $scope.signFileLakaut().then(function () {
                        $scope.isInProgress = false;
                        $state.go('paycheck-rrhh-find');
                    }, function (error) {
                        $scope.isInProgress = false;
                        errors.showError(error);
                    });
                };

                $scope.signFileLakaut = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;
                    var certificateTypeId = 1; // Empleador

                    fileWorkflowService.share($stateParams.id, certificateTypeId).then(function (response) {
                        // Create the outputURl
                        var output = config.apiUrl("SignedLakautCallback", 'wf');
                        profileCertificateService.certicateLakautSign(response, output, $scope.paycheck.organizationalUnitId).then(function (responseSign) {
                            defered.resolve();
                        }, function (error) {
                            defered.reject(error);
                        });

                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                };

                $scope.load();
            }
        ]);
})();
